import React, { useEffect, useState } from "react";
import "./NavbarNew.css";
import logo from "../../assets/img/header-logo.png";
import * as auth from "../../backend/auth";
import { preventDefault } from "../../utils/common";
import ChangePasswordModal from "../pages/Authenticate/ChangePasswordModal";
import ConfirmModal from "../common/ConfirmModal";
import { navigate } from "raviger";
import { getBasePath } from "../../App";
import Icon from "../common/Icon";
import NotificationsModal from "./NotificationsModal";

function NavbarNew({ showUser = true }) {
  const [user] = useState(auth.getUserDetails() || {});
  const [role, setRole] = useState("");
  const [roles, setRoles] = useState<any[]>([]);
  const [changePwd, setChangePwd] = useState(false);
  const [newUser, setNewUser] = useState(false);
  const [unreadNotifications, setUnreadNotifications] = useState<any>([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications] = useState([]);

  function logout(event: any) {
    preventDefault(event);
    auth.clearUserSession();
    setTimeout(() => {
      navigate(`${getBasePath()}/`);
      window.location.reload();
    });
  }

  function changeRole(_role: any) {
    const userDetails = auth.getUserDetails();
    if (!userDetails || !userDetails.roles) {
      return;
    }
    const index = userDetails.roles.findIndex((r: any) => r.id === _role.id);
    auth.setUserRole([_role]);
    setTimeout(() => {
      navigate(`${getBasePath()}/`);
      window.location.reload();
    });
  }

  useEffect(() => {
    if (user) {
      const _user = auth.getUserDetails();
      setNewUser(_user && !_user.last_login_date);
    }
  }, [user]);

  useEffect(() => {
    if (notifications) {
      setUnreadNotifications(
        notifications.filter((x: any) => !x.isRead).length
      );
    }
  }, [notifications]);

  useEffect(() => {
    if (showUser) {
      const _role = auth.getUserRole();
      setRole(_role);
      const { roles } = auth.getUserDetails();
      if (roles.length === 1) {
        setRoles([]);
      } else {
        setRoles(roles.filter((x: any) => x.name !== _role));
      }
    }
  }, [showUser]);

  return (
    <>
      <div className="container-full bg-white header-navbar-container shadow">
        <nav className="navbar navbar-expand-lg border-bottom">
          <div className="container-fluid">
            <div className="navbar-brand p-0">
              <img src={logo} alt="Logo" width="140" />
            </div>
            {showUser && (
              <>
                <div className="nav-item d-flex align-items-center">
                  {(notifications || []).length > 0 && (
                    <div className="p-2 position-relative">
                      <Icon
                        name="notification"
                        style={{ cursor: "pointer" }}
                        action={() => setShowNotifications(true)}
                      />
                      {unreadNotifications && (
                        <span className="notification-badge">
                          {unreadNotifications > 9 ? "9+" : unreadNotifications}
                        </span>
                      )}
                    </div>
                  )}
                  <ul className="navbar-nav px-2">
                    <div className="nav-item dropdown">
                      <div
                        className="nav-link dropdown-toggle text-black"
                        role="button"
                        aria-expanded="false"
                      >
                        <span className="userNameL rounded-circle fw-semibold text-center text-white">
                          {(user.name || "").charAt(0)}
                        </span>{" "}
                        <div>
                          <div className="fw-semibold text-md">{user.name}</div>
                          <div className="text-sm text-gray-500">{role}</div>
                        </div>
                      </div>
                      <div className="dropdown-menu">
                        <div className="px-3 text-md fw-bold">
                          Role:
                        </div>
                        <div className="px-3 pb-3">{role}</div>
                        {roles.length > 0 && (
                          <>
                            <div className="px-3 text-md fw-bold">
                              Login As:
                            </div>
                            {roles.map((_role: any) => {
                              return (
                                <div
                                  className="dropdown-item"
                                  key={_role.name}
                                  onClick={() => changeRole(_role)}
                                >
                                  {_role.name}
                                </div>
                              );
                            })}
                          </>
                        )}
                        <hr className="dropdown-divider" />
                        <a className="dropdown-item" href="/" onClick={logout}>
                          Logout
                        </a>
                      </div>
                    </div>
                  </ul>
                </div>
              </>
            )}
          </div>
        </nav>
      </div>
      {changePwd && <ChangePasswordModal onClose={() => setChangePwd(false)} />}
      {newUser && (
        <ConfirmModal
          title={`Hello ${user.name}`}
          message={
            "You are logged in with a temporary password. Would you like to change it?"
          }
          onSubmit={() => {
            setChangePwd(true);
          }}
          onClose={() => setNewUser(false)}
          yesText="Sure"
          noText="Maybe later"
        />
      )}
      {showNotifications && (
        <NotificationsModal
          notifications={notifications}
          onDismiss={() => setShowNotifications(false)}
          onSubmit={() => {
            setShowNotifications(false);
            // refetch();
          }}
        />
      )}
    </>
  );
}

export default NavbarNew;
